import { getSubdomainFranchise } from '../utils/get-subdomain';
import { httpInterceptor } from './http.interceptor';

class TelegramLogService {
  private subdomain: string;

  constructor() {
    this.subdomain = getSubdomainFranchise();
  }

  async send(send: boolean, message: string, dateCreated: Date, idvenda: number | null = null): Promise<any> {
    try {
      const response = await httpInterceptor.post('/telegram-logs', {
        send,
        message,
        idvenda,
        date_created: dateCreated
      });

      return null;
    } catch (erro) {
      return erro;
    }
  }

  async sendMatriz(send: boolean, message: string, dateCreated: Date, idvenda: number | null = null): Promise<any> {
    try {
      // Para matriz, precisamos usar headers especiais
      const response = await httpInterceptor.post('/telegram-logs', {
        send,
        message,
        idvenda,
        date_created: dateCreated
      }, {
        headers: {
          'x-api-key': btoa('matriz'),
        }
      });

      return null;
    } catch (erro) {
      return erro;
    }
  }
}

export const telegramLogService = new TelegramLogService();
